// extracted by mini-css-extract-plugin
export default {"comments":"PhotoComments_comments__9bGBg","single":"PhotoComments_single__cEZ7m"};